import moment from 'moment'
import getGradYear from '../get-grad-year'

const currentGradDate = moment([getGradYear(), 5, 1]).date(-1).format('YYYY-MM-DD')

export default currentGradDate